import { render, staticRenderFns } from "./ownerDiningList.vue?vue&type=template&id=3e6a4d67&scoped=true"
import script from "./ownerDiningList.vue?vue&type=script&lang=js"
export * from "./ownerDiningList.vue?vue&type=script&lang=js"
import style0 from "./ownerDiningList.vue?vue&type=style&index=0&id=3e6a4d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6a4d67",
  null
  
)

export default component.exports